import React, {Component} from 'react';
import {NotificationManager} from 'react-notifications';
import styled from "styled-components";

import {withUser} from '../../lib/user';
import {withLabels} from '../../lib/labels';
import * as api from '../../lib/api';
import * as actions from '../../state/actions';

import Screen from '../../components/Screen';
import {default as UnstyledContent} from '../../components/Content';
import Form from '../../components/Form';
import Input from '../../components/Input';
import Button from '../../components/Button';
import FileInput from '../../components/FileUpload';
import { AdminTabs } from './AdminTabs';
import {default as UnstyledSubHeader} from '../../components/SubHeader';
import { isValidCssColor } from '../../lib/color';

class AppearanceScreen extends Component {
  state = {
    saving: false,
    entered: {},
    applied: {},
    imagePreview: null
  }

  componentDidMount() {
    this.setState({applied:this.props.labels});
  }

  saveLabels = async () => {
    const {credentials, dispatch} = this.props;
    const {applied} = this.state;
    try {
      this.setState({saving: true});
      await api.saveLabels(applied, credentials);
      dispatch(actions.updateCompanySettings(applied));
      NotificationManager.success('Appearence settings saved');
      this.setState({entered: {}});
    }
    catch (e) {
      NotificationManager.error('There was an error saving settings')
    }
    finally {
      this.setState({saving: false});
    }
  }

  deleteLabels = async () => {
    const {credentials, dispatch} = this.props;
    try {
      await api.deleteLabels(credentials);
      dispatch(actions.updateCompanySettings({}));
      this.setState({applied: {}, entered: {}})
      NotificationManager.success('Reset appearance to default');
    }
    catch (e) {
      NotificationManager.error('There was an error deleting your settings');
    }
  }

  fileAdded(files) {
    if (files.length < 1) {
      this.setState({imagePreview: null, file: null});
    }
    else {
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({imagePreview: reader.result, file: files[0].file});
      }
      reader.readAsDataURL(files[0].file);
    }
  }

  uploadImage = async () => {
    const {file} = this.state;
    const {credentials, dispatch} = this.props;
    try {
      await api.uploadCompanyLogo(credentials, file, 
        //onSuccess
        (logo) => {
          dispatch(actions.updateCompanyLogo(logo));
          NotificationManager.success('Logo updated');
        },
        //on Failure
        () => {
          NotificationManager.error('Error updating logo');
        }
      );
    }
    catch (e) {
      NotificationManager.error('Error updating logo');
    }
  }

  deleteImage = async () => {
    const {credentials, dispatch} = this.props;
    try {
      await api.deleteCompanyLogo(credentials);
      dispatch(actions.updateCompanyLogo(null));
      NotificationManager.success('Logo removed');
    }
    catch(e) {
      NotificationManager.error('Could not remove logo');
    }
  }

  render() {
    return (
      <Screen title="Admin" activeLink="admin" labels={this.state.applied} logoSrc={this.state.imagePreview}>
        <AdminTabs />
        <Content>
          <SubHeader>Colors</SubHeader>
          <Form onSubmit={this.saveLabels} >
            <Form.Group>
              <Input
                id='backgroud-color-picker'
                label='Menu background color:'
                labelPosition='start'
                color={this.state.entered.sidebarBackgroundColor || this.state.applied.sidebarBackgroundColor || "#0049ee"}
                type='color'
                invalid={!isValidCssColor(this.state.entered.sidebarBackgroundColor || "#0049ee")}
                onChange={color => this.setState({
                  entered: {...this.state.entered, sidebarBackgroundColor: color},
                  applied: isValidCssColor(color) ? {...this.state.applied, sidebarBackgroundColor: color} : this.state.applied
                })}
              />
            </Form.Group>
            <Form.Group>
              <Input
                id='backgroud-color-picker'
                label='Menu text color:'
                labelPosition='start'
                color={this.state.entered.sidebarTextColor || this.state.applied.sidebarTextColor || "#FFFFFF"}
                type='color'
                invalid={!isValidCssColor(this.state.entered.sidebarTextColor || "#FFFFFF")}
                onChange={color => this.setState({
                  entered: {...this.state.entered, sidebarTextColor: color},
                  applied: isValidCssColor(color) ? {...this.state.applied, sidebarTextColor: color} : this.state.applied
                })}
              />
            </Form.Group>
            <ButtonGroup>
              <Button type="submit" disabled={this.state.saving || Object.keys(this.state.applied).length <= 0}>Save Colors</Button>
              {
                Object.keys(this.state.entered).length > 0 ?
                  <Button secondary onClick={() => this.setState({applied: this.props.labels, entered: {}})}>Restore defaults</Button>
                :
                  <Button secondary onClick={() => this.deleteLabels()}>Restore defaults</Button>
              }
            </ButtonGroup>
          </Form>
          <SubHeader>Logo</SubHeader>
          <Form onSubmit={this.uploadImage} >
            <Form.Group>
              <FileInput id="upload_logo" label="Select an image file" allowedTypes={["jpg", "gif", "png", "svg"]} onFilesAdd={(files) => this.fileAdded(files)} maxMB={2} />
            </Form.Group>
            <ButtonGroup>
              <Button type="submit" disabled={this.state.saving || !this.state.file}>Save Logo</Button>
              {
                this.state.file ?
                  <Button secondary onClick={() => this.setState({file: null, imagePreview: null})} >Restore defaults</Button>
                :
                  <Button secondary onClick={() => this.deleteImage()}>Restore defaults</Button>
              }
            </ButtonGroup>
          </Form>
        </Content>
      </Screen>
    )
  }
}

const Content = styled(UnstyledContent)`
  margin-top: 1.25rem;
`;

const SubHeader = styled(UnstyledSubHeader)`
  margin-bottom: 1.25rem;
`;

const ButtonGroup = styled(Form.Group)`
  margin-bottom: 3rem;

  Button {
    margin-right: 10px;
  }
`

export default withUser(withLabels(AppearanceScreen));